var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('alert-container'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('main',{attrs:{"role":"main"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"role":"banner"}},[_c('h1',{staticClass:"brand"},[_vm._v("Calm Network")])])
}]

export { render, staticRenderFns }